import { createSlotRecipe } from './runtime';

const accordionConfig = {"name":"accordion","slots":["root","item","itemTrigger","itemContent","itemIndicator"],"defaultVariants":{"size":"md"},"variantMap":{"size":["md"]}}

export const accordion = /* @__PURE__ */ createSlotRecipe(accordionConfig)